@if (!!asset) {
<div class="narrow-panel-container">
    <div class="narrow-panel-header">
        <div class="content-title-1"
             [matTooltip]="asset.name"
             [ngClass]="{'visible-settings-button': hasVehicleMgmtAccess$ | async}"
        >
            {{ asset.name }}
        </div>
        <div>
          <button
            (click)="toggleExpanded()"
            mat-icon-button
            [attr.aria-label]="expanded ? 'Collapse' : 'Expand'"
            [matTooltip]="expanded ? 'Collapse' : 'Expand'"
          >
            <mat-icon class="action-icon">
              @if (expanded) {
                collapse_content
              } @else {
                expand_content
              }
            </mat-icon>
          </button>
          <button
            mat-icon-button
            [routerLink]="['/' + RootRoute.MAIN, MainRoute.INSIGHTS, InsightsRoute.SHIFT_LOOKUP]"
            [queryParams]="{'category': 'vehicles', 'id': asset.id}"
            aria-label="history"
            [matTooltip]="'Vehicle\'s past shifts'"
          >
            <mat-icon class="action-icon">history</mat-icon>
          </button>
          @if (hasVehicleMgmtAccess$ | async) {
            <button
              [routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.MANAGE_VEHICLES, 'vehicle', asset.id]"
              mat-icon-button
              aria-label="settings"
              [matTooltip]="'Vehicle settings'"
            >
              <mat-icon class="action-icon">settings</mat-icon>
            </button>
          }
          <button
            (click)="close()"
            mat-icon-button
            aria-label="close"
          >
            <mat-icon class="action-icon">close</mat-icon>
          </button>
        </div>
    </div>

    <div class="narrow-panel-section" >
        <div class="content-title-2">
          @if (asset.shiftStatus !== ShiftState.ENDED) {
            @if (asset.shiftDevices !== ShiftDevices.LMU) {
              {{ asset.driverName }}@if(asset.driverIsGuest) {<span> - Guest</span>}
            }
          } @else {
            @if (asset.outOfService) {
              <button
                mat-button
                [routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.MANAGE_VEHICLES, 'vehicle', asset.id]"
                [queryParams]="{editStatus: true}"
                matTooltip="Edit Status"
                aria-label="manage-vehicle"
              >
                Out of Service
              </button>
            } @else {
              Offline
            }
          }
        </div>

        <div class="content-title-3">
          @if (asset.shiftStatus !== ShiftState.ENDED) {
            {{ assetMovementAndLocationDescription }}
          }
        </div>
    </div>

    @if (expanded) {
      @if (hasFeatureFlag(FeatureFlagEnum.DashCam) && asset.shiftStatus !== ShiftState.ENDED && !!asset.cameraConfiguration) {
        <div class="narrow-panel-section">
          <div class="content-paragraph">
            @if (imageLoading) {
              <mat-spinner diameter="18"></mat-spinner>
            }
            @if (!lastShiftImageModel) {
              <div>
                Dash Camera Images Not Available
              </div>
            }
            @if (!!lastShiftImageModel) {
              <app-image-viewer
                [images]="[lastShiftImageModel]"
                [isLiveMap]="true"
              ></app-image-viewer>
            }
          </div>
        </div>
      }

      @if (asset.shiftStatus === ShiftState.ENDED) {
        <div class="narrow-panel-section">
          <div class="content-paragraph">
            <button
              mat-button
              color="accent"
              type="submit"
              [routerLink]="['/' + RootRoute.MAIN, MainRoute.INSIGHTS, InsightsRoute.SHIFT_LOOKUP]"
              [queryParams]="{'category': 'vehicles', 'id': asset.id}"
            >
              View past shifts for this vehicle
            </button>
          </div>
        </div>
      }

      @if (asset.shiftStatus !== ShiftState.ENDED && asset.shiftDevices !== ShiftDevices.LMU) {
        <div class="narrow-panel-section space-between">
          <button
            mat-icon-button
            color="accent"
            [routerLink]="[]"
            [queryParams]="getRightPanelQueryParams(DrawerType.ROUTE)"
            [matTooltip]="'Assign route for the vehicle'"
          >
            <mat-icon>{{ DrawerType.ROUTE.icon }}</mat-icon>
          </button>
          <button
            mat-icon-button
            color="accent"
            [routerLink]="[]"
            [queryParams]="getRightPanelQueryParams(DrawerType.MESSAGES)"
            [matTooltip]="'Send message to driver'"
          >
            <mat-icon>{{ DrawerType.MESSAGES.icon }}</mat-icon>
          </button>
          <button
            mat-icon-button
            color="accent"
            [routerLink]="[]"
            [queryParams]="getRightPanelQueryParams(DrawerType.OBSERVATION)"
            [matTooltip]="'View vehicle observations'"
          >
            <mat-icon>{{ DrawerType.OBSERVATION.icon }}</mat-icon>
          </button>
          <!--<button
                  mat-icon-button
                  color="accent"
                  [routerLink]="[]"
                  [queryParams]="getRightPanelQueryParams(DrawerType.LIVE_VIDEO)"
                  [matTooltip]="'View live stream for the vehicle'"
                  [disabled]="!asset.cameraConfiguration"
                  *ngIf="hasFeatureFlag(FeatureFlagEnum.DashCam)"
          >
              <mat-icon>{{ DrawerType.LIVE_VIDEO.icon }}</mat-icon>
          </button>-->
          <button
            mat-icon-button
            color="accent"
            [routerLink]="[]"
            [queryParams]="getRightPanelQueryParams(DrawerType.ALERTS)"
            [matTooltip]="'Filter events for the vehicle'"
          >
            <mat-icon>{{ DrawerType.ALERTS.icon }}</mat-icon>
          </button>
          <!--button
                  mat-icon-button
                  color="accent"
                  [routerLink]="[]"
                  [queryParams]="getRightPanelQueryParams(DrawerType.QUICK_INSIGHTS)"
                  [matTooltip]="'Insights for the vehicle'"
          >
              <mat-icon>{{ DrawerType.QUICK_INSIGHTS.icon }}</mat-icon>
          </button-->
        </div>
      }

      @if (asset.shiftStatus !== ShiftState.ENDED) {
        <div class="narrow-panel-divider">
        </div>
      }

      @if (asset.shiftStatus !== ShiftState.ENDED) {
        <div class="narrow-panel-section">
          <div class="content-paragraph">
            <div class="content-row">
              <div class="info-name">
                <mat-icon>timer</mat-icon>
              </div>
              <div class="info-value ops-link" >
                {{ asset.shiftDuration | duration }} | started at <span [matTooltip]="asset.shiftStartTime | date: 'shortDate'">{{ asset.shiftStartTime | date: 'shortTime' }}</span>
              </div>
            </div>
            <div class="content-row">
              <div class="info-name">
                <mat-icon>pin</mat-icon>
              </div>
              @if (!!configuration) {
                <div class="info-value ops-link">
                  {{ (asset.distanceDriven | distance:configuration.useMetricSystem) || 'N/A' }}<span> driven</span>
                </div>
              }
            </div>
            @if (asset.vehicleLmuId) {
              <div class="content-row">
                <div class="info-name">
                  <mat-icon>vibration</mat-icon>
                </div>
                <div class="info-value ops-link">
                  LMU | {{ asset.vehicleLmuId }}
                </div>
              </div>
            }

            @if (asset.vehicleHardwareConfiguration &&
            asset.vehicleHardwareConfiguration.sensorInputs &&
            asset.vehicleHardwareConfiguration.sensorInputs.length > 0
            ) {
              @for (sensorInput of HardwareConfiguration.getValidInputs(asset.vehicleHardwareConfiguration.sensorInputs); track $index) {
                @if (sensorInput.type === SensorType.PLOW || sensorInput.type === SensorType.PLOW2W) {
                  <div class="content-row">
                    <div class="info-name">
                      <mat-icon class="mirrored">signal_cellular_1_bar</mat-icon>
                    </div>
                    <div class="info-value ops-link">
                      {{ !!sensorInput.label ? sensorInput.label : 'Plow' }} {{ sensorInput.bitNumber | plowStatus: asset.flags }}
                    </div>
                  </div>
                } @else if (sensorInput.type === SensorType.GRANULAR_SPREADER) {
                  <div class="content-row">
                    <div class="info-name">
                      <mat-icon>grain</mat-icon>
                    </div>
                    <div class="info-value ops-link">
                      {{ !!sensorInput.label ? sensorInput.label : 'Granular Spreader' }} {{ sensorInput.bitNumber | spreaderStatus: asset.flags }}
                      ({{ sensorInput.rate || 'N/A' }} {{'granular' | rateUnit:configuration.useMetricSystem}})
                    </div>
                  </div>
                } @else if (sensorInput.type === SensorType.DIGITAL_GRANULAR_SPREADER && !!asset.digitalGranularStatus) {
                  <div class="content-row">
                    <div class="info-name">
                      <mat-icon>grain</mat-icon>
                    </div>
                    <div class="info-value ops-link">
                      {{ !!sensorInput.label ? sensorInput.label : 'Digital Granular Spreader' }} {{ sensorInput.bitNumber | spreaderStatus: asset.flags }}
                      ({{ (asset.digitalGranularStatus.controllerCurrentRate | spreaderMass:configuration.useMetricSystem) || 'N/A' }})
                    </div>
                  </div>
                } @else if (sensorInput.type === SensorType.LIQUID_SPREADER) {
                  <div class="content-row">
                    <div class="info-name">
                      <mat-icon>water_drop</mat-icon>
                    </div>
                    <div class="info-value ops-link">
                      {{ !!sensorInput.label ? sensorInput.label : 'Liquid Spreader' }} {{ sensorInput.bitNumber | spreaderStatus: asset.flags }}
                      ({{ sensorInput.rate || 'N/A' }} {{ 'liquid' | rateUnit:configuration.useMetricSystem }})
                    </div>
                  </div>
                } @else if (sensorInput.type === SensorType.DIGITAL_LIQUID_SPREADER && !!asset.digitalLiquidStatus) {
                  <div class="content-row">
                    <div class="info-name">
                      <mat-icon>water_drop</mat-icon>
                    </div>
                    <div class="info-value ops-link">
                      {{ !!sensorInput.label ? sensorInput.label : 'Digital Liquid Spreader' }} {{ sensorInput.bitNumber | spreaderStatus: asset.flags }}
                      ({{ (asset.digitalLiquidStatus.controllerCurrentRate | spreaderLiquid:configuration.useMetricSystem) || 'N/A' }})
                    </div>
                  </div>
                } @else if (sensorInput.type === SensorType.MOWER) {
                  <div class="content-row">
                    <div class="info-name">
                      <mat-icon>grass</mat-icon>
                    </div>
                    <div class="info-value ops-link">
                      {{ !!sensorInput.label ? sensorInput.label : 'Mower' }} {{ sensorInput.bitNumber | mowerStatus: asset.flags }}
                    </div>
                  </div>
                } @else if (sensorInput.type === SensorType.SWEEPER) {
                  <div class="content-row">
                    <div class="info-name">
                      <mat-icon>cleaning_services</mat-icon>
                    </div>
                    <div class="info-value ops-link">
                      {{ !!sensorInput.label ? sensorInput.label : 'Sweeper' }} {{ sensorInput.bitNumber | sweeperStatus: asset.flags }}
                    </div>
                  </div>
                }
              }
            }
          </div>
        </div>
      }

      @if (asset.shiftDevices !== ShiftDevices.LMU) {
        <div class="narrow-panel-divider">
        </div>

        <div class="narrow-panel-section">
          <div class="content-title-2">
            Assignment Queue
          </div>

          <div class="content-paragraph">
            <app-route-assignment-queue
              [vehicle]="asset"
              [timeFromHoursFilter]="24"
            ></app-route-assignment-queue>
          </div>
        </div>
      }

      @if (asset.shiftStatus !== ShiftState.ENDED) {
        <div class="narrow-panel-divider">
        </div>

        <div class="narrow-panel-section">
          <div class="content-paragraph">
            <div class="space-between-row">
              <div>
                <span>Shift ID: </span>
                <a
                  [routerLink]="['/', RootRoute.MAIN, MainRoute.INSIGHTS, InsightsRoute.SHIFT_DETAIL, asset.shiftId]"
                  class="ops-link"
                >{{ asset.shiftId }}</a>
              </div>
              <button
                mat-button
                color="accent"
                type="submit"
                (click)="forceEndShift(asset.shiftId)"
              >
                End Shift
              </button>
            </div>
          </div>
        </div>
      }
    }
</div>
}
